export default __webpack_public_path__ + "static/media/Snapchat-913224619 - 402_SANIYA BHARGAV(1).d3c28ac0.jpg";